// @ts-nocheck
import { IBlock } from "../../../../framework/src/IBlock";
import { Message } from "../../../../framework/src/Message";
import { BlockComponent } from "../../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../../framework/src/RunEngine";
import { RouterProps } from "react-router";
import StorageProvider from "../../../../framework/src/StorageProvider.web";
import { DialogProps } from "../../../../components/src/DialogContext";
import { withAlertBoxProps } from "../../../../components/src/withAlertBox.Web";
import { withToastProps } from "../../../../components/src/withSnackBar.Web";
import { withLoaderProps } from "../../../../components/src/withLoader.Web";
export const configJSON = require("../config");

export type Props = RouterProps &
  DialogProps &
  withAlertBoxProps &
  withToastProps &
  withLoaderProps & {
    id: string;
    // Customizable Area Start
    // Customizable Area End
  };
interface S {
  // Customizable Area Start
  token: any;
  revenueGrowthTimePeriod: number;
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class RevenueGrowthChartDialogController extends BlockComponent<
  Props,
  S,
  SS
> {
  getOnBoardedClientDataForRevApiCallId: string = "";

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.AlertMessage),
      // Customizable Area End
    ];

    this.state = {
      token: "",
      revenueGrowthLineData: {
        labels: [],
        datasets: [],
      },
      revenueGrowthTimePeriod: 12,
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }
  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);
    if (message.id === getName(MessageEnum.RestAPIResponceMessage)) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (apiRequestCallId === this.getOnBoardedClientDataForRevApiCallId) {
        this.handleResponse(responseJson);
      }
    } else if (getName(MessageEnum.AlertMessage) === message.id) {
      const AlertBodyMessage = message.getData(
        getName(MessageEnum.AlertBodyMessage)
      );
      const msg = await this.props.showAlert({
        title: "Error",
        message: AlertBodyMessage,
      });
    }
  }
  handleResponse = (responseJson) => {
    this.props.hideLoader();
    if (responseJson?.last_quarter_revenue) {
      const is_last_quarter_revenue =
        Object.keys(responseJson?.last_quarter_revenue).length > 0;

      if (is_last_quarter_revenue) {
        const last_quarter_revenue_lables = Object.keys(
          responseJson?.last_quarter_revenue
        )?.reverse();
        const last_quarter_revenue_lineChartData = {
          labels: last_quarter_revenue_lables,
          datasets:
            Object.values(responseJson?.last_quarter_revenue)?.length > 0
              ? [
                  {
                    label: "",
                    data: Object.keys(responseJson?.last_quarter_revenue)
                      ?.reverse()
                      ?.map((pkg) => {
                        return Array.isArray(
                          responseJson?.last_quarter_revenue[pkg]
                        )
                          ? responseJson?.last_quarter_revenue[pkg]?.reduce(
                              (a, b) => a + b,
                              0
                            )
                          : responseJson?.last_quarter_revenue[pkg];
                      }),
                    borderColor: "#9CBE6A",
                    backgroundColor: "rgba(54, 162, 235, 1)",
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    pointHoverRadius: 4,
                    datalabels: {
                      align: "start",
                      anchor: "start",
                      font: {
                        family: "Nunito Sans",
                        size: 16,
                        weight: 400,
                      },
                      padding: 2,
                    },
                  },
                ]
              : [],
        };

        this.setState({
          revenueGrowthLineData: last_quarter_revenue_lineChartData,
        });
      }
    } else {
      this.handleApiErrorForChart(responseJson);
    }
  };
  handleApiErrorForChart = (rsp) => {
    if (typeof rsp?.errors === "string") {
      this.props.showToast({
        type: "error",
        message: rsp.errors,
      });
    } else {
      this.parseApiErrorResponse(rsp);
    }
  };
  getOnBoardedClientDataForRev = (mnth) => {
    const headers = {
      "content-type": "application/json",
      token: this.state.token,
    };
    this.props.showLoader();

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    this.getOnBoardedClientDataForRevApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_pricingcalculator/client_informations/client_onboarded?last_month=${mnth}`
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
}
